function nameFundStatus(status){
    switch(status){
        case '1': return '募集予定';
        case '2': return '募集中';
        case '3': return '募集終了';
        case '4': return '運用中';
        case '15': return '運用終了';
        case '5': return '償還済';
        case '6': return '途中終了';
        default: return 'その他';
    }
}

function statusColor(status) {
    switch (status) {
        case '1': return 'secondary';
        case '2': return 'primary';
        case '3': return 'secondary';
        case '4': return 'secondary';
        case '15': return 'secondary';
        case '5': return 'secondary';
        case '6': return 'secondary';
        default: return 'secondary';
    }
}

export default {
    nameFundStatus,
    statusColor,
};